// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as React from "react";
import * as $$String from "../../../../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Weekday from "../../../../../../../to-be-migrated/domain/types/common/Weekday.bs.js";
import * as Belt_List from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as FilterType from "../../../../../../app/entity/FilterType.bs.js";
import * as Belt_Option from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ListUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ListUtils.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as AllocationDashboardUtils from "../../../../utils/AllocationDashboardUtils.bs.js";
import * as TooltipComponent$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/tooltip/TooltipComponent.bs.js";
import * as TableWithRowHover$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableWithRowHover.bs.js";
import * as AllocationDashboardAssetsManager from "../../../../../assets/AllocationDashboardAssetsManager.bs.js";
import * as ZonalOrClusterCampaignPreviewVMMapper from "../../../../../view-model/zonal-cluster-campaigns-preview/ZonalOrClusterCampaignPreviewVMMapper.bs.js";

var arrowDropDownRedIcon = AllocationDashboardAssetsManager.getImage("red-arrow-drop-down.svg");

var arrowDropDownGreenIcon = AllocationDashboardAssetsManager.getImage("green-arrow-drop-down.svg");

function ZonalOrClusterAllocationCampaignsCmp$GetFilterOptions(Props) {
  var left_value = Props.left_value;
  var right_value = Props.right_value;
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "filter-options-unit-text"
                }, String(Belt_Option.getExn(left_value)) + "KM"), AllocationDashboardUtils.PreviewZonalOrClusterCampaigns.getDeltaValue(Belt_Option.getExn(left_value), right_value) !== 0.0 ? React.createElement("div", {
                    className: AllocationDashboardUtils.PreviewZonalOrClusterCampaigns.getDeltaValue(Belt_Option.getExn(left_value), right_value) > 0.0 ? "filter-options-delta-green-value" : "filter-options-delta-red-value"
                  }, String(AllocationDashboardUtils.PreviewZonalOrClusterCampaigns.toFixedDecimalPoint(AllocationDashboardUtils.PreviewZonalOrClusterCampaigns.getDeltaValue(Belt_Option.getExn(left_value), right_value), 2)), AllocationDashboardUtils.PreviewZonalOrClusterCampaigns.getDeltaValue(Belt_Option.getExn(left_value), right_value) > 0.0 ? React.createElement("img", {
                          src: arrowDropDownGreenIcon
                        }) : React.createElement("img", {
                          src: arrowDropDownRedIcon
                        })) : null);
}

var GetFilterOptions = {
  make: ZonalOrClusterAllocationCampaignsCmp$GetFilterOptions
};

function ZonalOrClusterAllocationCampaignsCmp$DisplayFilters(Props) {
  var filter_one = Props.filter_one;
  var filter_two = Props.filter_two;
  var filter_one_left_value = Props.filter_one_left_value;
  var filter_one_right_value = Props.filter_one_right_value;
  var filter_two_left_value = Props.filter_two_left_value;
  var filter_two_right_value = Props.filter_two_right_value;
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "filter-options-type"
                }, React.createElement("div", {
                      className: "filter-options-type-text"
                    }, filter_one), React.createElement(ZonalOrClusterAllocationCampaignsCmp$GetFilterOptions, {
                      left_value: filter_one_left_value,
                      right_value: filter_one_right_value
                    })), React.createElement("div", {
                  className: "filter-options-type"
                }, React.createElement("div", {
                      className: "filter-options-type-text"
                    }, filter_two), React.createElement(ZonalOrClusterAllocationCampaignsCmp$GetFilterOptions, {
                      left_value: filter_two_left_value,
                      right_value: filter_two_right_value
                    })));
}

var DisplayFilters = {
  make: ZonalOrClusterAllocationCampaignsCmp$DisplayFilters
};

function sortPriority(subType) {
  return subType + 1 | 0;
}

function getTableSchemaForZonalClusterCampaigns(zones, showClusterCampaigns, clusters, active_mandatory_campaign) {
  return {
          hd: TableWithRowHover$Catalyst.Schema.make_props({
                TAG: /* Custom */1,
                _0: (function (param) {
                    return React.createElement("p", undefined, "Campaign ID-Name");
                  })
              }, (function (apr) {
                  return {
                          TAG: /* Custom */5,
                          _0: (function (param) {
                              var match = apr.status;
                              var tmp;
                              switch (match) {
                                case /* Active */0 :
                                    tmp = React.createElement("label", {
                                          className: "active-icon"
                                        });
                                    break;
                                case /* Scheduled */1 :
                                    tmp = React.createElement("label", {
                                          className: "scheduled-icon"
                                        });
                                    break;
                                case /* PendingForReview */2 :
                                    tmp = null;
                                    break;
                                
                              }
                              return React.createElement("div", {
                                          className: "section-row"
                                        }, tmp, React.createElement(TooltipComponent$Catalyst.make, {
                                              content: String(apr.id) + " - " + apr.name,
                                              placement: /* Top_End */10,
                                              children: React.createElement("div", {
                                                    className: "campaign-name-container"
                                                  }, String(apr.id) + " - " + apr.name)
                                            }));
                            })
                        };
                }), undefined, undefined),
          tl: {
            hd: TableWithRowHover$Catalyst.Schema.make_props({
                  TAG: /* Custom */1,
                  _0: (function (param) {
                      return React.createElement("p", undefined, "Start Date/Time");
                    })
                }, (function (apr) {
                    return {
                            TAG: /* Custom */5,
                            _0: (function (param) {
                                var match = apr.day_start_hour;
                                var match$1 = apr.day_start_min;
                                var tmp;
                                var exit = 0;
                                if (match !== undefined && match$1 !== undefined) {
                                  tmp = React.createElement(React.Fragment, undefined, React.createElement("div", {
                                            className: "date-time-container"
                                          }, Timestamp$Catalyst.toString(apr.effective_from, "DD MMM YY") + ","), React.createElement("div", {
                                            className: "date-time-container"
                                          }, String(match) + ":" + String(match$1)));
                                } else {
                                  exit = 1;
                                }
                                if (exit === 1) {
                                  tmp = React.createElement("div", {
                                        className: "date-time-container"
                                      }, Timestamp$Catalyst.toString(apr.effective_from, "DD MMM YY"));
                                }
                                return React.createElement(React.Fragment, undefined, tmp);
                              })
                          };
                  }), undefined, undefined),
            tl: {
              hd: TableWithRowHover$Catalyst.Schema.make_props({
                    TAG: /* Custom */1,
                    _0: (function (param) {
                        return React.createElement("p", undefined, "End Date/Time");
                      })
                  }, (function (apr) {
                      return {
                              TAG: /* Custom */5,
                              _0: (function (param) {
                                  var date = apr.effective_till;
                                  var tmp;
                                  if (date !== undefined) {
                                    var date$1 = Caml_option.valFromOption(date);
                                    var match = apr.day_end_hour;
                                    var match$1 = apr.day_end_min;
                                    var exit = 0;
                                    if (match !== undefined && match$1 !== undefined) {
                                      tmp = React.createElement(React.Fragment, undefined, React.createElement("div", {
                                                className: "date-time-container"
                                              }, Timestamp$Catalyst.toString(date$1, "DD MMM YY") + ","), React.createElement("div", {
                                                className: "date-time-container"
                                              }, String(match) + ":" + String(match$1)));
                                    } else {
                                      exit = 1;
                                    }
                                    if (exit === 1) {
                                      tmp = React.createElement("div", {
                                            className: "date-time-container"
                                          }, Timestamp$Catalyst.toString(date$1, "DD MMM YY"));
                                    }
                                    
                                  } else {
                                    tmp = null;
                                  }
                                  return React.createElement(React.Fragment, undefined, tmp);
                                })
                            };
                    }), undefined, undefined),
              tl: {
                hd: TableWithRowHover$Catalyst.Schema.make_props({
                      TAG: /* Custom */1,
                      _0: (function (param) {
                          return React.createElement("p", undefined, showClusterCampaigns ? "List of Clusters" : "List of Zones");
                        })
                    }, (function (apr) {
                        return {
                                TAG: /* Custom */5,
                                _0: (function (param) {
                                    return React.createElement(React.Fragment, undefined, showClusterCampaigns ? React.createElement(TooltipComponent$Catalyst.make, {
                                                      content: ListUtils$Catalyst.toString(ZonalOrClusterCampaignPreviewVMMapper.mapClustersToId(clusters, Belt_List.fromArray(Belt_Option.getExn(apr.cluster_ids))), (function (a) {
                                                              return a;
                                                            }), undefined, undefined),
                                                      placement: /* Top_End */10,
                                                      children: React.createElement("div", {
                                                            className: "campaign-name-container"
                                                          }, ListUtils$Catalyst.toString(ZonalOrClusterCampaignPreviewVMMapper.mapClustersToId(clusters, Belt_List.fromArray(Belt_Option.getExn(apr.cluster_ids))), (function (a) {
                                                                  return a;
                                                                }), undefined, undefined))
                                                    }) : React.createElement(TooltipComponent$Catalyst.make, {
                                                      content: ListUtils$Catalyst.toString(ZonalOrClusterCampaignPreviewVMMapper.mapZonesToId(zones, Belt_List.fromArray(apr.zone_ids)), (function (a) {
                                                              return a;
                                                            }), undefined, undefined),
                                                      placement: /* Top_End */10,
                                                      children: React.createElement("div", {
                                                            className: "campaign-name-container"
                                                          }, ListUtils$Catalyst.toString(ZonalOrClusterCampaignPreviewVMMapper.mapZonesToId(zones, Belt_List.fromArray(apr.zone_ids)), (function (a) {
                                                                  return a;
                                                                }), undefined, undefined))
                                                    }));
                                  })
                              };
                      }), undefined, undefined),
                tl: {
                  hd: TableWithRowHover$Catalyst.Schema.make_props({
                        TAG: /* Custom */1,
                        _0: (function (param) {
                            return React.createElement("p", undefined, "Filter Details");
                          })
                      }, (function (apr) {
                          return {
                                  TAG: /* Custom */5,
                                  _0: (function (param) {
                                      var match = apr.sub_type;
                                      var tmp;
                                      switch (match) {
                                        case /* AllocationRadius */0 :
                                            tmp = React.createElement(ZonalOrClusterAllocationCampaignsCmp$DisplayFilters, {
                                                  filter_one: "Manual",
                                                  filter_two: "Auto",
                                                  filter_one_left_value: apr.values.manual,
                                                  filter_one_right_value: active_mandatory_campaign.filters.allocation_radius.manual,
                                                  filter_two_left_value: apr.values.auto,
                                                  filter_two_right_value: active_mandatory_campaign.filters.allocation_radius.auto
                                                });
                                            break;
                                        case /* DryRun */1 :
                                            tmp = React.createElement(ZonalOrClusterAllocationCampaignsCmp$DisplayFilters, {
                                                  filter_one: "Threshold",
                                                  filter_two: "Ratio",
                                                  filter_one_left_value: apr.values.threshold,
                                                  filter_one_right_value: active_mandatory_campaign.filters.dry_run.threshold,
                                                  filter_two_left_value: apr.values.ratio,
                                                  filter_two_right_value: active_mandatory_campaign.filters.dry_run.ratio
                                                });
                                            break;
                                        case /* MaxDryRun */2 :
                                            tmp = React.createElement(ZonalOrClusterAllocationCampaignsCmp$DisplayFilters, {
                                                  filter_one: "Manual",
                                                  filter_two: "Auto",
                                                  filter_one_left_value: apr.values.manual,
                                                  filter_one_right_value: active_mandatory_campaign.filters.maps_distance.manual,
                                                  filter_two_left_value: apr.values.auto,
                                                  filter_two_right_value: active_mandatory_campaign.filters.maps_distance.auto
                                                });
                                            break;
                                        
                                      }
                                      return React.createElement(React.Fragment, undefined, React.createElement("div", {
                                                      className: "filter-type-container"
                                                    }, React.createElement("div", {
                                                          className: "filter-type-text"
                                                        }, FilterType.toDisplayString(apr.sub_type))), React.createElement("div", {
                                                      className: "filter-options"
                                                    }, tmp));
                                    })
                                };
                        }), undefined, undefined),
                  tl: {
                    hd: TableWithRowHover$Catalyst.Schema.make_props({
                          TAG: /* Custom */1,
                          _0: (function (param) {
                              return React.createElement("p", undefined, "Days of Week");
                            })
                        }, (function (apr) {
                            return {
                                    TAG: /* Custom */5,
                                    _0: (function (param) {
                                        var match = List.length(apr.days_of_week);
                                        var tmp;
                                        if (match !== 7) {
                                          var days_in_string = List.map(Weekday.toString, apr.days_of_week);
                                          tmp = ListUtils$Catalyst.toString(days_in_string, (function (a) {
                                                  return $$String.sub(a, 0, 3);
                                                }), undefined, undefined);
                                        } else {
                                          tmp = "All";
                                        }
                                        return React.createElement("div", {
                                                    className: "days-of-week-container"
                                                  }, tmp);
                                      })
                                  };
                          }), undefined, undefined),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        };
}

function ZonalOrClusterAllocationCampaignsCmp(Props) {
  var showClusterCampaigns = Props.showClusterCampaigns;
  var zone_cluster_campaigns_list = Props.zone_cluster_campaigns_list;
  var zones = Props.zones;
  var clusters = Props.clusters;
  var active_mandatory_campaign = Props.active_mandatory_campaign;
  var zonal_or_cluster_active_scheduled_campaigns = List.sort((function (a, b) {
          return (a.sub_type + 1 | 0) - (b.sub_type + 1 | 0) | 0;
        }), List.filter(function (campaign) {
              return campaign.status !== /* PendingForReview */2;
            })(List.filter(function (c) {
                  var v = c.cluster_ids;
                  if (v === undefined) {
                    return showClusterCampaigns;
                  }
                  var match = v.length;
                  if (match !== 0) {
                    return showClusterCampaigns;
                  } else {
                    return !showClusterCampaigns;
                  }
                })(zone_cluster_campaigns_list.campaigns)));
  var match = Belt_List.length(zonal_or_cluster_active_scheduled_campaigns);
  if (match !== 0) {
    return React.createElement("div", {
                className: "c-mandatory-campaign-details"
              }, React.createElement("div", {
                    className: "ald-sidebar-zonal-cluster-campaign-table"
                  }, React.createElement("div", {
                        className: "ald-zonal-cluster-table-label"
                      }, React.createElement("p", undefined, showClusterCampaigns ? "Cluster" : "Zonal")), React.createElement(TableWithRowHover$Catalyst.make, {
                        columns: getTableSchemaForZonalClusterCampaigns(zones, showClusterCampaigns, clusters, active_mandatory_campaign),
                        row_data: zonal_or_cluster_active_scheduled_campaigns,
                        class_name: "allocation-dashboard-campaign-table"
                      })));
  } else {
    return null;
  }
}

var make = ZonalOrClusterAllocationCampaignsCmp;

export {
  arrowDropDownRedIcon ,
  arrowDropDownGreenIcon ,
  GetFilterOptions ,
  DisplayFilters ,
  sortPriority ,
  getTableSchemaForZonalClusterCampaigns ,
  make ,
  
}
/* arrowDropDownRedIcon Not a pure module */
